<template>
    <component v-bind:is="transformed"></component>
</template>

<script>
export default {
    name: "DynamicLink",
    props: {
        data: {
            type: Object,
        },
    },
    computed: {
        transformed() {
            const template = this.convert(this.data);
            return {
                template: template,
                props: this.$options.props
            }
        }
    },
    methods: {
        convert: function (data) {
            let innerText = data.text === null || data.text === undefined ? '' : data.text;
            let placeholder = innerText === '' ? ' class="placeholder"' : '';
            if (typeof data.column !== "undefined" && typeof data.column.route !== "undefined") {
                let ret = `<router-link :to='{ name: "${data.column.route.name}"`;
                if (typeof data.column.route.params !== "undefined") {
                    ret += `, params: ${this.getParams(data)}`;
                }
                ret += `}'><span ${placeholder}>${innerText}</span></router-link>`;
                return ret;
            } else {
                return '<span class="td">' + innerText + '</span>';
            }
            //return '<div>' + str.replace(/#([\w]+)/g, '<router-link to="/tag/$1">#$1</router-link>') + '</div>'
        },
        getParams(data) {
            let ret = {};
            data.column.route.params.forEach((param) => {
                let prop = param.value;
                if (prop === 'id' && data.row.parent_id !== null) {
                    prop = 'parent_id'
                }
                ret[param.name] = data.row[prop];
            });
            return JSON.stringify(ret);
        }
    },
}
</script>

<style scoped>

</style>